import { Route, BrowserRouter, Routes } from 'react-router-dom';
import { SignIn } from './Pages/SignIn/SignIn';
import { NewPassword } from './Pages/NewPassword/NewPassword';
import { ResetPassword } from './Pages/ResetPassword/ResetPassword';
import { ResetCode } from './Pages/ResetCode/ResetCode';
import { Dashboard } from './Pages/Dashboard/Dashboard';
import { AuthRedirect } from './Components/AuthRedirect/AuthRedirect';
import { LoaderProvider } from './hooks/LoaderContext';
import { AppInitProvider } from './context/AppInitContext';
import './App.scss';

function App() {
  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

  if (isMobile) {
    return (
      <div style={{
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '20px',
        textAlign: 'center'
      }}>
        Please use a computer to work with this application!
      </div>
    );
  }

  return (
    <LoaderProvider>
      <AppInitProvider>
        <BrowserRouter>
          <AuthRedirect />
          <Routes>
            <Route path="/sign-in" element={<SignIn />} />
            <Route path="/new-password" element={<NewPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/reset-code" element={<ResetCode />} />
            <Route path="/" element={<Dashboard />} />
          </Routes>
        </BrowserRouter>
      </AppInitProvider>
    </LoaderProvider>
  );
}

export default App;